import FixedMobileLayout from './FixedMobileLayout';

export default FixedMobileLayout;
